import React from 'react';

import { InfoChunky } from '@eb/eds-iconography';
import { Icon } from '@eb/eds-icon';
import { withTooltip } from '@eb/eds-tooltip';
import './infoTooltip.scss';

const IconWithTooltip = withTooltip(Icon);

interface InfoTooltipProps {
    tooltipId: string;
    arrowLocation: string;
    text: string;
    superscript?: true;
}

const InfoTooltip = ({
    tooltipId,
    arrowLocation,
    text,
    superscript,
}: InfoTooltipProps) => (
    <div className={superscript && 'infotooltip--superscript'}>
        <IconWithTooltip
            size="xsmall"
            color="ui-700"
            type={<InfoChunky />}
            tooltipId={tooltipId}
            tooltipStyle="phab"
            tooltipArrowLocation={arrowLocation}
            tooltipText={
                <p
                    className="eds-text-bs eds-text-weight--regular"
                    style={{ maxWidth: 150 }}
                >
                    {text}
                </p>
            }
        />
    </div>
);

export default InfoTooltip;
